export default "__VITE_ASSET__CzePanOF__"